export default "__VITE_ASSET__Tfp5b9M9__"